export class NativeStreamAggregationMetric {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "windowMinutes",
            "baseName": "windowMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "string",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "string",
            "format": ""
        },
        {
            "name": "hidden",
            "baseName": "hidden",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxKeys",
            "baseName": "maxKeys",
            "type": "number",
            "format": ""
        },
        {
            "name": "rankBy",
            "baseName": "rankBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "k",
            "baseName": "k",
            "type": "number",
            "format": ""
        },
        {
            "name": "lgK",
            "baseName": "lgK",
            "type": "number",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<NativeStreamAggregationSubMetric>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationMetric.attributeTypeMap;
    }
    constructor() {
    }
}
